import { render, staticRenderFns } from "./AfSolutionDetails.vue?vue&type=template&id=63360964&scoped=true&"
import script from "./AfSolutionDetails.vue?vue&type=script&lang=js&"
export * from "./AfSolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./AfSolutionDetails.vue?vue&type=style&index=0&id=63360964&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63360964",
  null
  
)

export default component.exports